"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BlDropzoneThumb = function (_a) {
    var onClick = _a.onClick, onRemove = _a.onRemove, path = _a.path;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.thumb_container, onClick: onClick },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.thumb },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.thumbInner },
                react_1.default.createElement("img", { src: path, className: styles_module_scss_1.default.img, alt: "" })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.remove },
                react_1.default.createElement(semantic_ui_react_1.Icon, { name: "remove", className: styles_module_scss_1.default.remove_icon, onClick: function (e) {
                        e.stopPropagation();
                        onRemove();
                    } })))));
};
exports.default = BlDropzoneThumb;
